function r(e, n, t) {
  e.prerender = function(...o) {
    Object.getPrototypeOf(e).prerender(), t.value.apply(this, o);
  };
}
function i(e, n, t) {
  e.postrender = function(...o) {
    Object.getPrototypeOf(e).postrender(), t.value.apply(this, o);
  };
}
function y(e, n, t) {
  e.destroy = function(...o) {
    Object.getPrototypeOf(e).destroy(), t.value.apply(this, o);
  };
}
const s = (e) => (n) => {
  n.mixins && Array.isArray(n.mixins) && (n.mixins = [...n.mixins, e]);
};
export {
  i as a,
  y as d,
  s as m,
  r as p
};
